/** Balance sheet sources */
export enum BalanceSheetSourceEnum {
  /** Debit turnover source */
  DEBIT_TURNOVER = 'DEBIT_TURNOVER',
  /** Credit turnover source */
  CREDIT_TURNOVER = 'CREDIT_TURNOVER',
  /** Balance turnover source */
  BALANCE_TURNOVER = 'BALANCE_TURNOVER',
  /** Initial balance source */
  INITIAL_BALANCE = 'INITIAL_BALANCE',
}
